
export const fontWeightsArray = ['100', '200', '300', '400', '500', '600', '700', '800', '900'];

export let fontSizesArray = [];

for (let i = 0; i < 201; i++) {
  fontSizesArray.push(`${i}px`);
  fontSizesArray.push(`${i/10}rem`);
  fontSizesArray.push(`${i/10}em`);
}



